<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :data-cy="`${entityName}__textField--${attributeName}Container`"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!required"
    :showHeader="showHeader"
  >
    <v-text-field
      :data-cy="`${entityName}__textField--${attributeName}`"
      :disabled="true"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="validatorList"
      :counter="counter"
      :solo="styleMap.solo"
      clearable
      required
      v-model="value"
    ></v-text-field>
  </component-wrapper>
</template>

<script>
import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  mixins: [userInputMixin],
  props: {
    ruleList: {
      type: Array,
    },
  },
};
</script>
